import { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { TableFilters } from '../../types';
import ScheduleTableFilters from '../../ScheduleTableFilters/ScheduleTableFilters';
import Button from '../../../Button/Button';
import styles from './MobileFilters.module.scss';

type MobileFiltersProps = {
  isOpen?: boolean;
  close: () => void;
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
  clearFilters: () => void;
};

const MobileFilters: FC<MobileFiltersProps> = ({
  isOpen,
  close,
  filters,
  setFilters,
  clearFilters,
}) => {
  return (
    <Dialog
      visible={isOpen}
      onHide={close}
      position="left"
      className={styles.mobileFilters}
      header={
        <header>
          <FontAwesomeIcon icon={faFilter} className={styles.filterIcon} />
          Filtros
        </header>
      }
    >
      <ScheduleTableFilters
        filters={filters}
        setFilters={setFilters}
        clearFilters={clearFilters}
      />
      <Button onClick={close} className={styles.applyButton}>
        Aplicar
      </Button>
    </Dialog>
  );
};

export default MobileFilters;
